import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    CustomReportSearchClient,
    CustomReportUserFavoriteClient,
    CustomReportView,
    SearchReportTemplateParameters
} from '.././reporting-api-proxies';
import { IReportsSearchService } from './custom-report-search.service';

@Injectable({
    providedIn: 'root'
})
export class CatalogReportSearchService implements IReportsSearchService<CustomReportView> {
    constructor(
        private readonly client: CustomReportSearchClient,
        private readonly favoriteClient: CustomReportUserFavoriteClient
    ) {}

    async searchReports(body: SearchReportTemplateParameters): Promise<CustomReportView[]> {
        return await lastValueFrom(this.client.customReportSearchSearchCatalogReports(body));
    }

    async toggleFavorite(id: number): Promise<boolean> {
        return await lastValueFrom(this.favoriteClient.customReportUserFavoriteToggleFavorite(id));
    }
}
